import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header d-flex justify-content-between" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "fas fa-spinner fa-spin ms-1"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "input-group text-nowrap" }
const _hoisted_12 = { class: "form-floating col" }
const _hoisted_13 = ["disabled", "readonly"]
const _hoisted_14 = { class: "form-floating col-3" }
const _hoisted_15 = ["disabled", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "card-title mb-0" }, [
          _createElementVNode("i", { class: "fab fa-bitcoin fa-fw me-2" }),
          _createElementVNode("span", null, "Cartera de Bitcoin (BTC)")
        ], -1)),
        _createElementVNode("div", null, [
          (_ctx.editMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelEdit())),
                  class: "btn btn-sm btn-outline-danger me-2"
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "fas fa-ban fa-fw me-1" }, null, -1),
                  _createTextVNode("Cancelar ", -1)
                ]))]),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-outline-success",
                  disabled: !_ctx.canSave || _ctx.saving,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.save()))
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-save fa-fw me-1" }, null, -1)),
                  _cache[7] || (_cache[7] = _createTextVNode("Guardar ", -1)),
                  (_ctx.saving)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_5)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit())),
                  class: "btn btn-sm btn-outline-secondary"
                }, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "fas fa-pen fa-fw" }, null, -1)
                ]))])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", {
                class: _normalizeClass(["input-group-text text-center col-2 col-sm-1", _ctx.readOnlyClasses]),
                id: "btc-icon"
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "fab fa-btc fa-fw mx-auto" }, null, -1)
              ]))], 2),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control text-center rounded-0", _ctx.readOnlyClasses]),
                  id: "btc-wallet",
                  ref: "btcWallet",
                  placeholder: "Wallet de Bitcoin (BTC)",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFinancialInfo.btcWallet.address) = $event)),
                  disabled: !_ctx.editMode,
                  readonly: !_ctx.editMode
                }, null, 10, _hoisted_13), [
                  [_vModelText, _ctx.localFinancialInfo.btcWallet.address]
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  for: "btc-wallet",
                  class: "opacity-100"
                }, " Wallet de Bitcoin (BTC) ", -1))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: _normalizeClass(["form-control fs-6 text-center rounded-0 rounded-end", _ctx.readOnlyClasses]),
                  id: "wallet-label",
                  placeholder: "Etiqueta",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFinancialInfo.btcWallet.label) = $event)),
                  disabled: !_ctx.editMode,
                  readonly: !_ctx.editMode
                }, null, 10, _hoisted_15), [
                  [_vModelText, _ctx.localFinancialInfo.btcWallet.label]
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  for: "wallet-label",
                  class: "opacity-100"
                }, [
                  _createElementVNode("i", { class: "fas fa-tag fa-fw" }),
                  _createTextVNode(" Etiqueta ")
                ], -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}